module.exports = __webpack_public_path__ + "static/media/IGStory.fe1c2173.jpg";